<template>
  <a-menu theme="dark" mode="inline" :defaultSelectedKeys="['1-1']" >
    <a-sub-menu key="1">
      <span slot="title">
        <a-icon type="copyright"/>
        <span>品牌与商品</span>
      </span>
      <a-menu-item key="1-1">
        <router-link to="/product">
          <a-icon type="barcode"/>
          <span class="nav-text">商品管理</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="1-2">
        <router-link to="/brand">
          <a-icon type="tags"/>
          <span class="nav-text">品牌管理</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="1-3">
        <router-link to="/manufacturer">
          <a-icon type="appstore"/>
          <span class="nav-text">生产厂商</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="1-4">
        <router-link to="/productGroup">
          <a-icon type="branches"/>
          <span class="nav-text">商品分类</span>
        </router-link>
      </a-menu-item>
    </a-sub-menu>
    <a-menu-item key="3">
      <router-link to="/event">
        <a-icon type="gift"/>
        <span class="nav-text">活动管理</span>
      </router-link>
    </a-menu-item>
    <a-menu-item key="2">
      <router-link to="/user">
        <a-icon type="user"/>
        <span class="nav-text">用户管理</span>
      </router-link>
    </a-menu-item>
  </a-menu>
</template>
<script>
export default {
  name: "menus"
};
</script>

